import React from "react";
import Styles from "./RaisedBox.module.css";
function RaisedBox(props) {
  return (
    <div className={Styles.EntireRaisedBox} style={{ ...props.styles }}>
      {props.children}
    </div>
  );
}

export default RaisedBox;
